import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { FALLBACK_LANGUAGE } from '../../legal/terms-content';
import { type ILanguageState } from '../reducers/language/types';

function PrivacyNoticeLink(): React.JSX.Element {
  const { t } = useTranslation();
  const languageCode: string = useSelector(
    ({ Language }: { Language?: ILanguageState }): string =>
      Language?.languageType.code ?? FALLBACK_LANGUAGE,
  ).toLowerCase();

  return (
    <p className="privacy-notice">
      {t('privacyNotice.text')}{' '}
      <Link to={`/${languageCode}/privacy-policy`}>
        {t('privacyNotice.linkLabel')}
      </Link>
    </p>
  );
}

export default PrivacyNoticeLink;
